import { useState, useRef } from "react";
import FlySubMenu from '../NavBarMenu/FlySubMenu';

const FlyMenuItem = ({ menu,menu_length }) => {
  const [open, setOpen] = useState(false);
  const closeTimer = useRef(null);
  const isAdmin = menu?.menu_details?.title === "Admin";
console.log("menu----->",menu)
  const openMenu = () => {
    clearTimeout(closeTimer.current);
    setOpen(true);
  };

  const closeMenu = () => {
    closeTimer.current = setTimeout(() => {
      setOpen(false);
    }, 40);
  };

  return (
    <div
      className={`top-menu-item ${isAdmin ? "admin-menu" : ""}`}
      onMouseEnter={openMenu}
      onMouseLeave={closeMenu}
    >
      <span className="icon" style={{ color: 'white' }}>
        {menu.menu_details.icon}
      </span>
      <span style={{ color: "#fff" }}>
        {menu?.menu_details?.title == "ORGANIZATION" ? "ORG" : menu?.menu_details?.title == "Human Resource" ? "HR/TA" : menu?.menu_details?.title}
        {open && (
          <FlySubMenu submenus={menu?.submenus} menu_length={menu_length}/>
        )}
      </span>

      {/* {open && (
        <FlySubMenu submenus={menu?.submenus} />
      )} */}
    </div>
  );
};

export default FlyMenuItem;
